import React, { useEffect, useState } from "react";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import { Paper } from "@mui/material";
import { Box } from "@mui/system";
function Filters({
  cars,
  filters,
  appliedFilters,
  setAppliedFilters,
  setFilteredCars,
  settings,
}) {
  const addFilter = (item, arrayName) => {
    let tempFilters = appliedFilters;
    !appliedFilters?.[arrayName]?.includes(item)
      ? tempFilters[arrayName].push(item)
      : (tempFilters[arrayName] = tempFilters[arrayName].filter(
          (key) => key !== item
        ));
    //tenta
    setAppliedFilters(tempFilters);

    const tempCars = cars?.filter(
      (car) =>
        (tempFilters?.FUEL.length === 0 ||
          tempFilters?.FUEL.includes(car?.traitMap.FUEL)) &&
        (tempFilters?.LUGGAGE.length === 0 ||
          tempFilters?.LUGGAGE.includes(car?.traitMap.LUGGAGE)) &&
        (tempFilters?.TRANSMISSION.length === 0 ||
          tempFilters?.TRANSMISSION.includes(car?.traitMap.TRANSMISSION))
    );

    setFilteredCars(tempCars);
  };
  useEffect(() => {
    setFilteredCars(cars);
  }, [cars]);
  const wrap = ({ children }) => {
    return;
  };
  return (
    <Box className="filterBox">
      <h2 className="filterBoxHeader">{settings?.FILTERS_HEADER}</h2>
      <div className="filterBoxFilter">
        <span className="filterBox-filter-title">{settings?.FUEL}</span>
        <FormGroup>
          {filters?.FUEL.map((item) => (
            <FormControlLabel
              key={item}
              control={
                <Checkbox
                  onClick={() => addFilter(item, "FUEL")}
                  checked={appliedFilters?.FUEL.includes(item)}
                />
              }
              label={item}
            />
          ))}
        </FormGroup>
      </div>
      <div className="filterBoxFilter">
        <span className="filterBox-filter-title">{settings?.LUGGAGE}</span>
        <FormGroup>
          {filters?.LUGGAGE.map((item) => (
            <FormControlLabel
              key={item}
              control={
                <Checkbox
                  onClick={() => addFilter(item, "LUGGAGE")}
                  checked={appliedFilters.LUGGAGE.includes(item)}
                />
              }
              label={item}
            />
          ))}
        </FormGroup>
      </div>
      <div className="filterBoxFilter">
        <span className="filterBox-filter-title">{settings?.TRANSMISSION}</span>
        <FormGroup>
          {filters?.TRANSMISSION.map((item) => (
            <FormControlLabel
              key={item}
              control={
                <Checkbox
                  onClick={() => addFilter(item, "TRANSMISSION")}
                  checked={appliedFilters.TRANSMISSION.includes(item)}
                />
              }
              label={item}
            />
          ))}
        </FormGroup>
      </div>
    </Box>
  );
}

export default Filters;
